<template src="./templates/live-edit.html" />

<script type="text/ecmascript-6">
import FouAccordion from 'components/tools/fou-accordion/'
import FouAccordionItem from 'components/tools/fou-accordion/item'
import FouContainer from 'src/components/tools/fou-container/'
import SubmissionLoading from 'src/pages/submissions/components/loading/'
import { SubmissionObject, errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import LiveSubmissionMethods from 'src/pages/submissions/script/live.methods'
import FouGroup from 'src/components/layout/fou-group/'
import FouGrid from 'src/components/layout/fou-grid/'
import FouModal from 'src/components/overlay/fou-modal/'
import Upload from 'src/pages/submissions/components/upload/'
import Prices from 'src/pages/submissions/components/prices/'
import Descriptions from 'src/pages/submissions/components/descriptions/'
import Graphics from 'src/pages/submissions/components/graphics/'
import MessageHistory from 'src/pages/submissions/components/message-history/'
import Methods from 'src/pages/submissions/script/index.methods'
import { mapActions, mapGetters } from 'vuex'
import Misc, { isEqualIgnoreCase } from 'src/utils/helper/misc'
import LoadAnimation from 'components/animations/loading'
import Channels from 'src/pages/submissions/components/channels/'
import FouTextArea from 'src/components/form/text-area/index.vue'
import { Toaster } from 'src/utils/helper/toaster'
import { useForm } from 'vee-validate'
import { isEmpty } from 'lodash'
import { adobeCjaEventEmitter } from 'modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_NAMES, LINK_SECTION } from 'modules/adobe-cja/constants'

export default {
  name: 'SubmissionsCorrect',

  components: {
    FouAccordion,
    FouAccordionItem,
    FouContainer,
    FouGroup,
    ...FouGrid,
    FouModal,
    Upload,
    Prices,
    Descriptions,
    Graphics,
    SubmissionLoading,
    MessageHistory,
    LoadAnimation,
    Channels,
    FouTextArea,
    Toaster
  },

  beforeRouteLeave(to, from, next) {
    this.newBinaryIds = []
    next()
  },

  setup() {
    const { errors } = useForm()
    return {
      errors,
      submissionErrors
    }
  },

  data() {
    return {
      ...SubmissionObject,
      description: '',
      ready: {
        name: this.$options.name,
        state: 'unset'
      },
      modalOptions: {
        cols: '',
        content: []
      },
      isUpdateModal: false,
      updateModalData: [],
      selectedLabels: [],
      modalErrors: [],
      newBinaryIds: [],
      uniqueStyleErrors: [],
      uniqueMD5Errors: [],
      canceledModal: false,
      openSubmit: false,
      submitClicked: false,
      beforeunloadFlag: false,
      editInProgress: false,
      uniqueOldSkuPackages: []
    }
  },

  computed: {
    ...SubmissionComputed,
    ...mapGetters('binaries', {
      allBinaries: ['list'],
      newBinaries: ['newList'],
      updateModal: ['getUpdateModal'],
      getScanStatus: ['getScanStatus'],
      getFilesWithFalseAvStatus: ['getFilesWithFalseAvStatus'],
      getLiveModalCancelButton: ['getLiveModalCancelButton']
    }),
    ...mapGetters('submissions', {
      isAnimating: ['liveSpinner'],
      isSubmitting: ['processing'],
      hideModalStatus: ['modalStatus'],
      updateSubmissionAPI: ['updateSubmissionApi']
    }),
    ...mapGetters('graphics', ['scanStatus', 'getImagesWithMalware']),
    hasAllPSNames() {
      // Adding computed porperty for all ps names and all style names to enable disabled button
      return !this.$store.getters['binaries/list'].every(font => {
        return (font.hasOwnProperty('styleName') &&
          font.styleName !== '' &&
          font.hasOwnProperty('fontInfo') &&
          font.fontInfo.hasOwnProperty('psName') &&
          font.fontInfo.psName !== '')
      })
    },
    /**
     * Computed property that returns filtered released binaries for each item
     * Excludes already selected options to prevent duplicate mappings
     */
    filteredUpdateModalData() {
      if (!this.updateModalData || this.updateModalData.length === 0) {
        return []
      }

      // Get currently selected binary IDs (excluding placeholder values)
      const selectedBinaryIds = this.selectedLabels
        .filter(label => label && label !== 'select' && label !== 'add' && label !== 'n/s')
        .filter(Boolean) // Remove any null/undefined values

      return this.updateModalData.map((item, index) => {
        // Get the current selection for this dropdown
        const currentSelection = this.selectedLabels[index]
        
        // Filter released binaries to exclude already selected options
        // But keep the current selection for this dropdown and special options
        const filteredReleasedBinaries = item.releasedBinaries.filter(binary => {
          // Always keep placeholder and special options
          if (binary.binaryId === 'select' || binary.binaryId === 'add') {
            return true
          }
          
          // Keep the current selection for this dropdown
          if (binary.binaryId === currentSelection) {
            return true
          }
          
          // Exclude if already selected in another dropdown
          return !selectedBinaryIds.includes(binary.binaryId)
        })

        // Return the item with filtered released binaries
        return {
          ...item,
          releasedBinaries: filteredReleasedBinaries
        }
      })
    },
    ...mapGetters('auth', ['hasRole']),
  },
  watch: {
    isAnimating: function (newV, oldV) {
      if (!newV && oldV) {
        this.hide()
        this.selectedLabels = []
      }
    },
    hideModalStatus: function (newV, oldV) {
      if (oldV === 'open' && newV === 'hide') {
        this.navigateToSubmissionSuccess(this, 'live')
        this.hide()
      }
    },
    newBinaries: {
      handler: function (newV, oldV) {
        let malwareBinaries = newV.filter((item) => item.avStatus === 'false').map((item) => item.id);
        if (malwareBinaries.length > 0) {
          this.$store.commit('binaries/setLiveModalCancelButton', true)
          if(malwareBinaries.length == newV.length) {
            this.newBinaryIds = [];
          } 
          malwareBinaries.push('true')
          this.$events.$emit('cancel:live-modal', malwareBinaries);
          this.nextick(this.renderModal, this.$refs.updateModal)
          for (const id of malwareBinaries) {
            this.$store.commit('binaries/deleteBins', [id])
            this.$store.commit('binaries/deleteNewBinaries', id)
            const index = this.updateModalData.findIndex(item => item.newBinary.id === id);
              if (index !== -1) {
                this.updateModalData.splice(index, 1);
                this.selectedLabels.splice(index, 1);
              }
          }
        }
      },
    },
  },

  created() {
    if(!this.hasRole(['foundrySupport'])) {
      this.$store.dispatch('profile/getFoundries')
    }
    window.addEventListener('beforeunload', this.showToastNotification)
    this.resetSubmissionStore()
    SubmissionObject.readyComplete = false
    this.setSubscription()
    this
      .addReadyState()
    this.$store.commit('submissions/setFormat', this.getFormatFromRoute())
    this
      .startSubmission()
      .then(() => {
        this.notEditable()
        this.setDefaultUser()
        this.updateSubmissionSteps()
        this.ready.state = 'set'
        this.$events?.$on('openUpdateModal', () => {
          if (!this.updateModal) {
            this.isUpdateModal = false
          } else {
            this.isUpdateModal = true
          }
        })
        this.$events?.$on('get_new_binaries', () => {
          if (!this.shouldProcessNewBinaries()) return;

          this.canceledModal = false;
          this.newBinaryIds = this.newBinaries.map((item) => item.id);

          let binIds = this.getFilteredBinaryIds();
          this.getBinariesPSNames(binIds);
        });
      })
    this.$events?.$on('live_update:cancel', this.resetPage)
    this.$events?.$on('check:style unique name', (binaryCollection) => {
      this.checkUniqueStyle()
      this.checkUniqueMD5(binaryCollection)
      this.uniqueStyleErrors = [...this.uniqueStyleErrors, ...this.uniqueMD5Errors]
    })
    this.$events?.$on('closeUpdateModal', () => {
      this.isUpdateModal = false
    })
  },
  mounted() {
    window.addEventListener('beforeunload', this.showToastNotification)
  },
  beforeUnmount() {
    this.$events.$off('openUpdateModal')
    this.$events.$off('live_update:cancel')
    this.$events.$off('get_new_binaries')
    this.$events.$off('check:style unique name')
    this.$store.commit('binaries/clearFilesWithFalseAvStatus');
    window.removeEventListener('beforeunload', this.showToastNotification)
  },

  methods: {
    ...SubmissionMethods,
    ...LiveSubmissionMethods,
    ...mapActions('overlay', ['hide', 'show']),
    ...Methods,
    ...Misc,
    shouldProcessNewBinaries() {
      return this.isUpdateModal &&
        this.newBinaries.some(item =>
          item?.fontInfo?.psName
        );
    },

    getFilteredBinaryIds() {
      let ids = this.submissionBinaries
        .map(val => (val.binaryId && !val.hasOwnProperty('status')) ? val.binaryId : undefined)
        .filter(id => id !== undefined);

      return ids.filter(id => !this.newBinaryIds.includes(id));
    },
    showToastNotification(event) {
      if(this.updateSubmissionAPI){
        event.preventDefault()
        event.returnValue = '';
      }
    },
    notEditable() {
      if (!this.isEditable) {
        this.$router.replace({ name: 'home' })
      }
    },
    accordionItemClass(section) {
      return [
        this.$style.item,
        { [this.$style.complete]: this.step(section).complete },
        { [this.$style.error]: this.step(section).anyErrors() }
      ]
    },
    checkUniqueOldSku(packages) {

      const oldSkuCounts = {};

      // Count occurrences of each oldSku and skuId
      packages?.forEach(pkg => {
        const oldSku = pkg.oldSku;
        const skuId = pkg.skuId;

        if (oldSku !== "0") {
          if (!oldSkuCounts[oldSku]) oldSkuCounts[oldSku] = 0;
          oldSkuCounts[oldSku]++;
        }

        if (skuId !== "0") {
          if (!oldSkuCounts[skuId]) oldSkuCounts[skuId] = 0;
          oldSkuCounts[skuId]++;
        }
      });
      // Filter out packages where oldSku appears more than once in either oldSku or skuId
      const duplicatedSkus = [];
      for (const [key, value] of Object.entries(oldSkuCounts)) {
        if (value === 2 && key !== "0") {
          duplicatedSkus.push(key);
        }
      }
      return duplicatedSkus;
    },
    checkForSingleStyleSP() {
      if (!this.submission.isLive || this.submission?.userMetaData?.packages?.length === 0) return;
      const singlePack = this.filterPackagesByType('singleStyle');
      if (singlePack?.length === 0) return;

      this.processFilteredPacks(singlePack);
      this.updateAndNotify();
    },
    filterPackagesByType(packageType) {
      return this.submission.userMetaData?.packages.filter(pkg => pkg.packageType === packageType);
    },

    processFilteredPacks(packages) {
      const filteredPacks = packages?.filter(pack => pack.oldSku === "0" && pack.skuId === "0");
      filteredPacks?.forEach(pack => this.updatePackWithMatchedBinary(pack));
    },
    updatePackWithMatchedBinary(pack) {
      const matchedBinary = this.findMatchingBinary(pack);
      if (!matchedBinary) return;

      const getSubmissionList = JSON.parse(window.localStorage.getItem('getSubmissionList'));
      getSubmissionList?.userMetaData.packages.forEach(oldPack => {
        if (this.isMatchingPackage(matchedBinary, oldPack)) {
          this.updatePackSku(pack, oldPack);
        }
      });
    },
    findMatchingBinary(pack) {
      return this.submissionBinaries.find(binary =>
        pack.styles[0].binaryId === binary.binaryId && binary.status === 'updated');
    },

    isMatchingPackage(matchedBinary, oldPack) {
      return matchedBinary?.oldBinary === oldPack.styles[0]?.binaryId && oldPack.packageType === 'singleStyle';
    },
    updatePackSku(pack, oldPack) {
      pack.oldSku = oldPack.oldSku !== '0' ? oldPack.oldSku : oldPack.skuId;
      pack.skuId = 0;
    },
    updateAndNotify() {
      const updatedSinglePack = this.filterPackagesByType('singleStyle');
      this.uniqueOldSkuPackages = this.checkUniqueOldSku(updatedSinglePack);
      if (this.uniqueOldSkuPackages.length > 0) {
        Toaster.notifyWarn("We're almost there! Please refresh the page to complete this step.");
        this.hide()
      }
    },
    submitLiveCorrection() {
      const tags = this.submissionTags || []
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.FONT_FAMILY_TAGS,
          linkSection: LINK_SECTION.SUBMISSIONS,
          linkName: LINK_NAMES.SUBMIT_NEXT,
          linkType: LINK_TYPES.BUTTON
        },
        Tags: tags.map(tag => ({
          TagName: tag.name,
          TagType: tag.id === 'AI_GENERATED' ? 'AI_GENERATED' : 'user'
        }))
      })
      this.submission.description = this.description || ''
      const inReview = true
      this.setDefaultUser()
      this.$store.commit('submissions/submitStart')
      this.nextick(this.renderModal, this.$refs.submitModal)
      this.$store.commit('submissions/onUpdtSubmsnHideModal', 'open')
      this.checkForSingleStyleSP()
      if (this.uniqueOldSkuPackages.length === 0) {
        this.updateSubmission(inReview)
      }
    },
    validateSubmission() {
      if(this.$store.getters['bannedword/checkForBannedWord']) {
        return ; 
      }
      if (this.submissionTags.length > 1100) {
        Toaster.notifyError(this.$t('pages.submissions.components.descriptions.tags.maxTagsReached'));
        return;
      }
      this.submitClicked = false
      this.checkUniqueStyle()
      this.checkUniqueMD5(this.$store.getters['binaries/list'])
      this.uniqueStyleErrors = [...this.uniqueStyleErrors, ...this.uniqueMD5Errors]
      this.$events.$emit('trigger:validate')
      setTimeout(() => {
        this.submitClicked = isEmpty(submissionErrors.value) && !this.uniqueStyleErrors.length && this.submissionBinaries.length > 0
      }, 500)
    },
    exit() {
      this
        .$store
        .dispatch('submissions/reset')
        .then(() => {
          this.$store.commit('binaries/clear')
          this.$store.commit('designers/clear')
          this.$store.commit('graphics/clear')
          this.$store.commit('tags/clear')
          SubmissionObject.reset()
        })
      this.$router.push({
        name: 'released_submissions_details',
        id: this.getSubmissionIdFromRoute(),
        format: this.getFormatFromRoute()
      })
      this.hide()
    },
    resetPage() {
      if (this.isUpdateModal) {
        this.isUpdateModal = false
        this.updateModalData = []
        this.modalErrors = []
        this.canceledModal = true
        this.$events.$emit('cancel:live-modal', this.newBinaryIds)
        this.nextick(this.renderModal, this.$refs.updateModal)
      } else {
        this.hide()
      }
    },
    getBinariesPSNames(dropdwnBinaries = []) {
      let allBinaries = Misc.getNewArrayForLive(this.allBinaries)
      allBinaries = allBinaries.filter(item => dropdwnBinaries.some(other => item.binaryId === other))
      const newBinaries = Misc.getNewArrayForLive(this.newBinaries)
      const releasedBinaries = Misc.getDiffArrayFromAll(allBinaries, newBinaries)
      const placeHolder = { binaryId: 'select', psName: 'Select style', fileName: 'Select style', styleName: 'Select style' }
      const addNewLabel = { binaryId: 'add', psName: 'Create new style', fileName: 'Create new style', styleName: 'Create new style' }
      releasedBinaries.unshift(placeHolder, addNewLabel)
      this.getModalMapper(newBinaries, releasedBinaries)
      this.getSelectedLabels()
      const selected = Object.assign([], this.selectedLabels)
      const updateData = Object.assign([], this.updateModalData)
      this.selectedLabels = selected
      this.updateModalData = updateData
      this.nextick(this.renderModal, this.$refs.updateModal)
    },
    getModalMapper(newData, releaseData) {
      for (const [key, item] of newData.entries()) {
        const i = Misc.findIndex(this.updateModalData, { newBinary: { id: item.binaryId } })
        if (i > 0 && (this.updateModalData[i].psName === 'n/a' || this.updateModalData[i].psName === '')) {
          this.updateModalData[i] = Misc.mapperObject(item.binaryId, item.psName, item.fileName, item.styleName, releaseData)
        } else {
          this.updateModalData[key] = Misc.mapperObject(item.binaryId, item.psName, item.fileName, item.styleName, releaseData)
        }
      }
    },
    getSelectedLabels() {
      for (const [key, value] of this.updateModalData.entries()) {

        if (value.newBinary.psName === 'n/a') {
          this.selectedLabels[key] = 'n/s'
        } else {
          let selectedPSName = value.releasedBinaries.filter(data => isEqualIgnoreCase(data.psName, value.newBinary.psName))
          selectedPSName = selectedPSName.length === 0 ? 'select' : selectedPSName[0].binaryId
          if (this.selectedLabels[key] === undefined || this.selectedLabels[key] === 'n/s') {
            this.selectedLabels[key] = selectedPSName
          }
        }
      }
    }
  }
}
</script>
<style src="./stylesheets/index.scss" lang="scss" module></style>
